import React from 'react';
import LegalPageLayout from './LegalPageLayout';
import { Link } from 'react-router-dom';

const CopyrightDmcaPage: React.FC = () => (
  <LegalPageLayout title="Copyright and DMCA" updated="October 5, 2026">
    <p>
      If you believe content on Bilt:Spec infringes your copyright, send a notice to <a href="mailto:copyright@biltspec.com">copyright@biltspec.com</a>
      or submit a copyright request from <Link to="/settings/privacy">Privacy and data</Link>.
    </p>
    <h2>What to include</h2>
    <ul>
      <li>Your contact information</li>
      <li>Description of the copyrighted work</li>
      <li>URL or location of the allegedly infringing material</li>
      <li>A statement of good-faith belief that use is not authorized</li>
      <li>A statement under penalty of perjury that the information is accurate and that you are the owner or authorized agent</li>
      <li>Your physical or electronic signature</li>
    </ul>
    <h2>Important</h2>
    <p>
      Tangents LLC has not completed formal DMCA designated-agent registration unless separately confirmed. This page
      describes an operational intake process and requires legal review before relying on statutory safe-harbor language.
    </p>
    <h2>Counter-notice</h2>
    <p>If your content was removed and you believe that was a mistake, contact <a href="mailto:copyright@biltspec.com">copyright@biltspec.com</a> with a counter-notice.</p>
  </LegalPageLayout>
);

export default CopyrightDmcaPage;
